module.exports = __webpack_public_path__ + "static/img/ex_b1.6666c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_b1.jpg
// module id = GquI
// module chunks = 1